var React = require('react');

function IcPause24px (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 19h4V5H6v14zm8-14v14h4V5h-4z"}));
}

IcPause24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcPause24px;

IcPause24px.default = IcPause24px;
